/**
 * Asset category mappings for Stats page asset makeup table
 */

export type AssetCategory = "Stablecoins" | "Basis Trades (Hedged)";

/**
 * Category to assets mapping (symbols should be uppercase).
 *
 * "Basis Trades (Hedged)" covers Layer-1 collateral held against on-exchange
 * short perp positions — the cash-and-carry yield trade. Renamed from
 * the literal "Layer 1s" so the label reflects the *strategy* rather
 * than just the asset class.
 */
export const ASSET_CATEGORY_TO_ASSETS: Record<AssetCategory, readonly string[]> = {
    Stablecoins: ["USDG", "USDC", "USDT"],
    "Basis Trades (Hedged)": ["BTC", "SOL", "ETH", "XRP"]
} as const;

/**
 * Convenience reverse map: asset symbol -> category
 */
export const ASSET_TO_CATEGORY: Readonly<Record<string, AssetCategory>> = Object.freeze(
    Object.entries(ASSET_CATEGORY_TO_ASSETS).reduce(
        (acc, [category, assets]) => {
            for (const sym of assets) acc[sym.toUpperCase()] = category as AssetCategory;
            return acc;
        },
        {} as Record<string, AssetCategory>
    )
);

/**
 * Get the category for a given asset symbol
 */
export function getAssetCategory(symbol: string): AssetCategory | undefined {
    return ASSET_TO_CATEGORY[symbol.toUpperCase()];
}

/**
 * Get all assets in a category
 */
export function getAssetsInCategory(category: AssetCategory): readonly string[] {
    return ASSET_CATEGORY_TO_ASSETS[category];
}
